// app/frontend/router/routes.js
export default [
  {
    path: '/',
    name: 'Home',
    component: () => import('../pages/Home.vue'),
  },
  {
    path: '/demos/audit-ia',
    name: 'DemoAuditIa',
    component: () => import('../pages/demos/DemoAuditAutomatisation.vue'),
  },
  {
    path: '/demos/automatisation-process',
    name: 'DemoAutomatisationProcess',
    component: () => import('../pages/demos/DemoExtractionPdf.vue'),
  },
  {
    // Démonstration client diffusée aux adhérents de l'UNSPIC : URL courte et lisible, hors
    // /demos/, pour qu'un lien reçu par mail inspire confiance.
    path: '/unspic-chatbot',
    name: 'UnspicChatbot',
    component: () => import('../pages/UnspicChatbot.vue'),
  },
  {
    path: '/demos/veille-automatisee',
    name: 'DemoVeilleAutomatisee',
    component: () => import('../pages/demos/DemoVeillePersonnalisee.vue'),
  },
  {
    path: '/demos/dashboards-sur-mesure',
    name: 'DemoDashboardsSurMesure',
    component: () => import('../pages/demos/DemoCrmPersonnalise.vue'),
  },
  // Administration du chatbot de l'UNSPIC (corpus et règles), derrière une session Devise.
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../pages/admin/AdminLogin.vue'),
  },
  {
    path: '/admin',
    component: () => import('../components/admin/AdminLayout.vue'),
    meta: { requiresAdmin: true },
    children: [
      { path: '', redirect: { name: 'AdminDocuments' } },
      {
        path: 'corpus',
        name: 'AdminDocuments',
        component: () => import('../pages/admin/AdminDocuments.vue'),
      },
      {
        path: 'corpus/nouveau',
        name: 'AdminDocumentNew',
        component: () => import('../pages/admin/AdminDocumentEdit.vue'),
      },
      {
        path: 'corpus/:id',
        name: 'AdminDocumentEdit',
        component: () => import('../pages/admin/AdminDocumentEdit.vue'),
        props: true,
      },
      {
        path: 'regles',
        name: 'AdminSettings',
        component: () => import('../pages/admin/AdminSettings.vue'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../pages/NotFound.vue'),
  },
]
